module.exports = __webpack_public_path__ + "static/media/DisputesDeflectorBanner.d3365905.png";